"use client"

import * as React from "react"
import {
  ChevronDown,
  Download,
  Upload,
  FileText,
  Image,
  Square,
  LandmarkIcon as Landscape,
  PaintbrushIcon as Portrait,
  PenIcon,
} from "lucide-react"
import { Button } from "./ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card"
import { Checkbox } from "./ui/checkbox"
import { Input } from "./ui/input"
import { Label } from "./ui/label"
import { RadioGroup, RadioGroupItem } from "./ui/radio-group"
import { Textarea } from "./ui/textarea"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible"
import { Separator } from "./ui/separator"
import { Facebook, Instagram, X } from "@mui/icons-material"
import { downloadImage, downloadSVG } from '../utils/downloadImage';
import { fabric } from 'fabric';

interface DownloadSidebarProps {
  canvas: fabric.Canvas;
}

const DownloadSidebar = ({ canvas }: DownloadSidebarProps) => {
  const [transparentBackground, setTransparentBackground] = React.useState(false) as any;
  const [ctrlcOption, setCtrlcOption] = React.useState<string | null>("paisagem");
  const [quality, setQuality] = React.useState("alta")
  const [qualityOpen, setQualityOpen] = React.useState(false)
  const [pdfOptionsOpen, setPdfOptionsOpen] = React.useState(false)
  const [vectorOptionsOpen, setVectorOptionsOpen] = React.useState(false)
  const [printsOptionsOpen, setPrintsOptionsOpen] = React.useState(false)
  const [ctrlcOptionsOpen, setCtrlcOptionsOpen] = React.useState(false)
  const [vistasOptionsOpen, setVistasOptionsOpen] = React.useState(false)
  const [instagranOptionsOpen, setInstagramOptionsOpen] = React.useState(false)
  const [facebookOptionsOpen, setFacebookOptionsOpen] = React.useState(false)
  const [xOptionsOpen, setXOptionsOpen] = React.useState(false)
  const [pdfText, setPdfText] = React.useState("")
  const [namesList, setNamesList] = React.useState("")
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setSelectedFile(file)
    }
  }

  function handleCtrlcSelect(option: string) {
    (window as { [key: string]: any }).ctrlc = option;
    localStorage.setItem("ctrlc", option);
    setCtrlcOption((prev) => (prev === option ? null : option));
  }

  (window as { [key: string]: any }).handleCtrlcSelect = function (option: string) {
    handleCtrlcSelect(option)
  }

  function handleTransparentChange(checked: boolean) {
    setTransparentBackground(checked);

    (window as { [key: string]: any }).transpCoisa = checked;

    {/**if (checked) {
    // Quando ativado
    renderer.setClearColor(0x000000, 0); // fundo transparente
  } else {
    // Quando desativado
    renderer.setClearColor(0xffffff, 1); // por exemplo, fundo branco
  } */}
  }

  return (
    <Card className="w-80 h-fit bg-card/85">
      <CardHeader className="pb-4">
        <CardTitle className="text-xl font-bold">DOWNLOAD</CardTitle>
        <CardDescription className="text-sm text-muted-foreground">
          Caso queira utilizar o vetor no CorelDRAW, recomendamos que você baixe o vetor em PDF e importe para evitar
          conflitos
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-6">
        {/* Transparent Background */}
        <div className="flex items-center space-x-2">
          <Checkbox id="background-transparent" checked={transparentBackground} onCheckedChange={handleTransparentChange} />
          <Label htmlFor="background-transparent" className="text-sm font-medium">
            Fundo Transparente
          </Label>
        </div>

        {/* Quality Section */}
        {/**<Collapsible open={qualityOpen} onOpenChange={setQualityOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">Qualidade</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <RadioGroup value={quality} onValueChange={setQuality} className="space-y-3">
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="alta" id="alta" />
                <Label htmlFor="alta" className="text-sm">
                  Alta
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="media" id="media" />
                <Label htmlFor="media" className="text-sm">
                  Média
                </Label>
              </div>
            </RadioGroup>
          </CollapsibleContent>
        </Collapsible> */}

        {/* CTRLC Section */}
        <Collapsible open={ctrlcOptionsOpen} onOpenChange={setCtrlcOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">CTRLC</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <div className="flex items-center space-x-2">
              <Checkbox
                id="ctrlcPaisagem"
                checked={ctrlcOption === "paisagem"}
                onCheckedChange={() => handleCtrlcSelect("paisagem")}
              />
              <Label htmlFor="ctrlcPaisagem" className="text-sm font-medium">
                Paisagem
              </Label>
            </div>

            <div className="flex items-center space-x-2 mt-2">
              <Checkbox
                id="ctrlcRetrato"
                checked={ctrlcOption === "retrato"}
                onCheckedChange={() => handleCtrlcSelect("retrato")}
              />
              <Label htmlFor="ctrlcRetrato" className="text-sm font-medium">
                Retrato
              </Label>
            </div>

            <div className="flex items-center space-x-2 mt-2">
              <Checkbox
                id="ctrlcQuadrado"
                checked={ctrlcOption === "quadrado"}
                onCheckedChange={() => handleCtrlcSelect("quadrado")}
              />
              <Label htmlFor="ctrlcQuadrado" className="text-sm font-medium">
                Quadrado
              </Label>
            </div>
          </CollapsibleContent>
        </Collapsible>


        {/* Prints Section */}
        <Collapsible open={printsOptionsOpen} onOpenChange={setPrintsOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">Capturas</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="3600" data-height="1800" data-title="captura-paisagem"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Landscape className="w-4 h-4 mr-2" />
              Paisagem Alta
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1920" data-height="1080" data-title="captura-paisagem"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Landscape className="w-4 h-4 mr-2" />
              Paisagem Baixa
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1800" data-height="3600" data-title="captura-retrato"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Portrait className="w-4 h-4 mr-2" />
              Retrato Alta
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="1920" data-title="captura-retrato"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Portrait className="w-4 h-4 mr-2" />
              Retrato Baixa
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="3800" data-height="3800" data-title="captura-quadrado"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Square className="w-4 h-4 mr-2" />
              Quadrado Alta
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="1080" data-title="captura-quadrado"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Square className="w-4 h-4 mr-2" />
              Quadrado Baixa
            </Button>
          </CollapsibleContent>
        </Collapsible>

        {/* Vistas Section */}
        <Collapsible open={vistasOptionsOpen} onOpenChange={setVistasOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">Vistas</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">

            {/**<Button
              id="download-vistas" data-title="frente-e-costas"
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
            >
              <Download className="w-4 h-4 mr-3" />
              <Image className="w-4 h-4 mr-2" />
              Frente e Costas
            </Button>
 */}
            <Button
              id="download-vistas" data-title="lados"
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Image className="w-4 h-4 mr-2" />
              Lados
            </Button>

            <Button
              id="obj-vetor"
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <Image className="w-4 h-4 mr-2" />
              3D e Vetor
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
              onClick={() => (window as any).abrirPainelAprovacao()}
            >
              <Download className="w-4 h-4 mr-3" />
              <Image className="w-4 h-4 mr-2" />
              360
            </Button>

            {/**<Button
              id="download-vistas2" data-title="360"
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
            >
              <Download className="w-4 h-4 mr-3" />
              <Image className="w-4 h-4 mr-2" />
              360
            </Button> */}
          </CollapsibleContent>
        </Collapsible>

        {/* Instagran Section 
        <Collapsible open={instagranOptionsOpen} onOpenChange={setInstagramOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">Instagran</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="1080" data-title="instagram-feed-quadrada"
            >
              <Download className="w-4 h-4 mr-3" />
              <Instagram className="w-4 h-4 mr-2" />
              Feed (Publicação quadrada)
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="1350" data-title="instagram-feed-retrato"
            >
              <Download className="w-4 h-4 mr-3" />
              <Instagram className="w-4 h-4 mr-2" />
              Feed (Retrato)
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="566" data-title="instagram-feed-paisagem"
            >
              <Download className="w-4 h-4 mr-3" />
              <Instagram className="w-4 h-4 mr-2" />
              Feed (Paisagem)
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="1920" data-title="instagram-stories-reels"
            >
              <Download className="w-4 h-4 mr-3" />
              <Instagram className="w-4 h-4 mr-2" />
              Stories e Reels
            </Button>
          </CollapsibleContent>
        </Collapsible>*/}

        {/* Facebook Section 
        <Collapsible open={facebookOptionsOpen} onOpenChange={setFacebookOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">Facebook</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1200" data-height="1200" data-title="facebook-feed-quadrada"
            >
              <Download className="w-4 h-4 mr-3" />
              <Facebook className="w-4 h-4 mr-2" />
              Feed (Imagem quadrada)
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1200" data-height="630" data-title="facebook-feed-horizontal"
            >
              <Download className="w-4 h-4 mr-3" />
              <Facebook className="w-4 h-4 mr-2" />
              Feed (Imagem retangular horizontal)
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1080" data-height="1920" data-title="facebook-stories"
            >
              <Download className="w-4 h-4 mr-3" />
              <Facebook className="w-4 h-4 mr-2" />
              Stories
            </Button>
          </CollapsibleContent>
        </Collapsible>*/}

        {/* X Section 
        <Collapsible open={xOptionsOpen} onOpenChange={setXOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">X / Twitter</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1600" data-height="900" data-title="x-paisagem"
            >
              <Download className="w-4 h-4 mr-3" />
              <X className="w-4 h-4 mr-2" />
              Imagem no feed (paisagem)
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5 download-jpg-3d"
              data-width="1200" data-height="1200" data-title="x-quadrada"
            >
              <Download className="w-4 h-4 mr-3" />
              <X className="w-4 h-4 mr-2" />
              Imagem quadrada (menos comum)
            </Button>
          </CollapsibleContent>
        </Collapsible>*/}

        {/* Vector Section */}
        <Collapsible open={vectorOptionsOpen} onOpenChange={setVectorOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">Vetor</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">
            <Button
              id="wwwwwwwww"
              onClick={() => downloadSVG(canvas.toSVG())}
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
            >
              <Download className="w-4 h-4 mr-3" />
              <FileText className="w-4 h-4 mr-2" />
              Vetor SVG
            </Button>

            <Button
              id="download-svg-pdf"
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <FileText className="w-4 h-4 mr-2" />
              Vetor PDF
            </Button>

            <Button
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
              onClick={() => downloadImage(canvas.toDataURL(), 'png', 'image/png')}
            >
              <Download className="w-4 h-4 mr-3" />
              <Image className="w-4 h-4 mr-2" />
              Vetor JPG
            </Button>
          </CollapsibleContent>
        </Collapsible>

        {/* PDF Section */}
        <Collapsible open={pdfOptionsOpen} onOpenChange={setPdfOptionsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="w-full justify-between p-0 h-auto">
              <span className="text-sm font-medium">PDF</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${qualityOpen ? "rotate-180" : ""}`} />
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-3">

            <Button
              id="download-pdf"
              variant="outline"
              className="w-full justify-start h-12 text-sm font-medium mb-5"
              onClick={() => {}}
            >
              <Download className="w-4 h-4 mr-3" />
              <FileText className="w-4 h-4 mr-2" />
              Ficha Técnica
            </Button>

            <div className="space-y-2 flex items-center">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%]">
                Nome do Projeto
              </Label>
              <input id="val-1" className="h-5 !mt-0 text-foreground" type="text" />
            </div>

            <div className="space-y-2 flex items-center mt-4">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%]">
                Nome do Cliente
              </Label>
              <input id="val-2" className="!mt-0 h-5 text-foreground" type="text" />
            </div>

            <div className="space-y-2 flex items-center mt-4">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%]">
                Nome do Designer
              </Label>
              <input id="val-3" className="!mt-0 h-5 text-foreground" type="text" />
            </div>

            <div className="space-y-2 flex items-center mt-4">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%]">
                Número do Pedido
              </Label>
              <input id="val-4" className="!mt-0 h-5 text-foreground" type="text" />
            </div>

            <div className="space-y-2 flex items-center mt-4">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%]">
                Data de Entrega
              </Label>
              <input id="val-5" className="!mt-0 h-5 text-foreground" type="date" />
            </div>

            <div className="space-y-2 flex items-center mt-4">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%]">
                Quantidade
              </Label>
              <input id="val-6" className="!mt-0 h-5 text-foreground" type="number" />
            </div>

            <div className="space-y-2 flex items-start mt-4">
              <Label htmlFor="pdf-text" className="text-sm font-medium w-[50%] pt-1">
                Comentários
              </Label>
              <Textarea
                id="val-8"
                placeholder=""
                value={pdfText}
                onChange={(e) => setPdfText(e.target.value)}
                className="min-h-[100px] resize-y w-[50%] !mt-0 text-foreground"
              />
            </div>

            {/* PDF Text Input 
            <div className="space-y-2">
              <Label htmlFor="pdf-text" className="text-sm font-medium">
                Texto do Termo PDF
              </Label>
              <Textarea
                id="termo-pdf"
                placeholder="Texto do termo PDF"
                value={pdfText}
                onChange={(e) => setPdfText(e.target.value)}
                className="min-h-[80px] resize-none"
              />
            </div>*/}

            {/* Names List Input 
            <div className="space-y-2">
              <Label htmlFor="names-list" className="text-sm font-medium">
                Lista de nomes e números para o PDF (exemplo: nome,número,tamanho (enter))
              </Label>
              <Textarea
                id="lista-pdf"
                placeholder="Digite a lista de nomes e números..."
                value={namesList}
                onChange={(e) => setNamesList(e.target.value)}
                className="min-h-[80px] resize-none"
              />
            </div>*/}

            {/* Logo Upload 
            <div className="space-y-2">
              <Label htmlFor="logo-upload" className="text-sm font-medium">
                Logo para o PDF (Quadrada)
              </Label>
              <div className="flex items-center gap-2">
                <Input id="logo-pdf" type="file" accept="image/*" onChange={handleFileChange} className="hidden" />
                <Button
                  variant="outline"
                  onClick={() => document.getElementById("logo-pdf")?.click()}
                  className="w-full justify-start"
                >
                  <Upload className="w-4 h-4 mr-2" />
                  {selectedFile ? selectedFile.name : "Escolher arquivo"}
                </Button>
              </div>
              {!selectedFile && <p className="text-xs text-muted-foreground">Nenhum arquivo escolhido</p>}
            </div>*/}
          </CollapsibleContent>
        </Collapsible>
      </CardContent>
    </Card>
  )
}

export default DownloadSidebar